import React, { useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import SearchIcon from 'Images/SVG/Search.svg'
import { FlexDiv } from 'components/generic/HomePageComponents'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { StyledInput } from 'components/Directories/Styled'
import { DirectoryLinkAs, DirectoryLinkHref, withSearchQuery } from 'utils/DirectoryParser'
import { KeywordSearchButton } from './Styled'

const MainContainer = (props) => (
  <FlexDiv
    borderRadius='5px'
    border='1px #ccc solid'
    width={{ desktop: '220px' }}
    height='34px'
    mt='4px'
    {...props}
    justifyContent='space-between'
  />
)

const TextInput = ({ placeholder, textValue, directoryLinkInformation }) => {
  const router = useRouter()
  const [inputValue, setInputValue] = useState(textValue)
  const directorySearchQueryInformation = withSearchQuery(directoryLinkInformation, inputValue)
  const as = DirectoryLinkAs(directorySearchQueryInformation)
  const href = DirectoryLinkHref(directorySearchQueryInformation)

  const catchEnterKeyPress = (ev) => {
    if (ev && (ev.which === 13 || ev.key === 'Enter' || ev.code === 'Enter')) {
      router.replace(href, as, { shallow: true })
    }
  }

  return (
    <MainContainer>
      <StyledInput
        type='text'
        name='search'
        placeholder={placeholder}
        value={inputValue || ''}
        onChange={(ev) => setInputValue(ev.currentTarget.value)}
        onKeyDown={(ev) => catchEnterKeyPress(ev)}
      />
      <Link scroll={false} as={as} href={href}>
        <KeywordSearchButton>
          <GenericLazyLoadImage src={SearchIcon} width='15px' />
        </KeywordSearchButton>
      </Link>
    </MainContainer>
  )
}

export default TextInput
